import { render } from "./MyMontyConfigurationPage.vue?vue&type=template&id=a8560006"
import script from "./MyMontyConfigurationPage.vue?vue&type=script&lang=js"
export * from "./MyMontyConfigurationPage.vue?vue&type=script&lang=js"

import "./MyMontyConfigurationPage.vue?vue&type=style&index=0&id=a8560006&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__